(() => {
  function setContainerHeight() {
    const containers = document.querySelectorAll(".autoheight");

    containers.forEach((container) => {
      const image = container.querySelector("img");

      if (image) {
        const width = container.offsetWidth;
        const ratio = image.naturalHeight / image.naturalWidth;
        const height = width * ratio;

        container.style.height = `${height}px`;
      }
    });
  }

  window.addEventListener("resize", setContainerHeight);
  setContainerHeight();
})();
